<div class="flex flex-col gap-4">
	<div class="text-lg">Are you sure?</div>
	This will remove all changes to your current matter and restore default
	statement of account settings from business settings.
</div>
